export const GENERATION_PREFERENCES = [
  {
    nameKey: "onboarding.preferences.product_descriptions",
    value: "product_descriptions",
  },
  { nameKey: "onboarding.preferences.blog_posts", value: "blog_posts" },
  { nameKey: "onboarding.preferences.ads", value: "ads" },
];

export const MARKETPLACES = [
  { nameKey: "onboarding.marketplaces.shopify", value: "shopify" },
  { nameKey: "onboarding.marketplaces.wix", value: "wix" },
  { nameKey: "onboarding.marketplaces.amazon", value: "amazon" },
];
